import { applyMiddleware, createStore, compose } from "redux";
import App from "./pages/app";
import { Route, Router, Switch } from "react-router-dom";
import Connection from "./pages/connection";
import history from "./history";
import { Provider } from "react-redux";
import React from "react";
import raceRefreshMiddleware from "./middlewares/race-refresh";
import reducer from "./reducer";
import { render } from "react-dom";
import ScrollToTop from "./components/scroll-to-top";
import thunkMiddleware from "redux-thunk";
import TvBoard from "./pages/tv-board";
import TVBoardBasic from "./pages/tv-board-basic";

// magic to make webpack copy images
require.context("../public/videos/", true, /\.(mp4|ogg)/); // eslint-disable-line no-undef
require.context("../public/images/", true, /\.(jpe?g|png|gif|svg|ico)$/); // eslint-disable-line no-undef
require.context("../public/fonts/", true, /\.(svg|ttf|woff)/); // eslint-disable-line no-undef
require.context("../public/", true, /\.js/); // eslint-disable-line no-undef

const middlewares = applyMiddleware(thunkMiddleware, raceRefreshMiddleware);
const store = compose(middlewares, window.devToolsExtension ? window.devToolsExtension() : f => f)(createStore)(reducer);

export default function renderMain() {
  render(
    <Provider store={store}>
      <Connection>
        <Router history={history}>
          <ScrollToTop>
            <Switch>
              <Route component={TvBoard} path="/tournaments/:id/tvboard" />

              <Route component={TVBoardBasic} path="/tournaments/:id/tvboard-basic" />

              <Route component={App} path="/" />
            </Switch>
          </ScrollToTop>
        </Router>
      </Connection>
    </Provider>, document.getElementById("container"));
}
